export enum BuildingType {
  Commercial = 'Commercial',
  Residential = 'Residential',
  Industrial = 'Industrial',
  Medical = 'Medical',
  Educational = 'Educational',
  Government = 'Government',
  Retail = 'Retail',
  Other = 'Other',
}

export enum WallMountingMaterial {
  Drywall = 'Drywall',
  Plywood = 'Plywood',
  Concrete = 'Concrete',
  Other = 'Other',
}

export enum SignalStrength {
  Excellent = 'Excellent',
  Good = 'Good',
  Fair = 'Fair',
  Poor = 'Poor',
  NoSignal = 'No Signal',
}

export enum CellCarrier {
  Verizon = 'Verizon',
  TMobile = 'T-Mobile',
  ATT = 'AT&T',
}
